export default __webpack_public_path__ + "static/media/anhngoi1.9daf8585.jpg";